module.exports = "img.secured{border-radius:0 !important}\n"